import React, { useEffect, useState } from 'react';
import styles from './CaseArchivePage.module.scss';
import { BackButton } from '@/components/BackButton';
import { useNavigate } from 'react-router-dom';
import { useNavMenuStore } from '@/store/useNavMenuStore';
import { getCases } from '@/api/modules/Case/case';
import { ReactComponent as StarIcon } from '@/assets/Icons/star.svg';
import { Loader } from '@/components/Loader/Loader';

const CaseArchivePage = () => {
  const [casesArchive, setCasesArchive] = useState([]);
  const [loading, setLoading] = useState(false);
  console.log(casesArchive, 'CASES ARCHIVE');
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate('/case');
  };

  const handleResultsClick = (safeEventId: string) => {
    navigate(`/case/archive/${safeEventId}`);
  };

  useEffect(() => {
    const fetchCases = async () => {
      setLoading(true);
      try {
        const res = await getCases();
        setCasesArchive(
          res.events.filter((item: any) => item.status === 'finished'),
        );
      } catch (error) {
        console.error('Ошибка при загрузке архива:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchCases();
  }, []);

  useEffect(() => {
    useNavMenuStore.getState().setVisibility(false);
    return () => {
      useNavMenuStore.getState().setVisibility(true);
    };
  }, []);

  if (loading) {
    return (
      <div>
        <Loader />
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <BackButton onClick={handleBackClick} />
      <div className={styles.content}>
        <h1 className={styles.title}>
          Архив
          <br />
          турниров:
        </h1>
        <div className={styles.casesArchiveList}>
          {casesArchive.map((caseItem: any, index: number) => (
            <div
              key={caseItem.safe_event_id || index}
              className={styles.archiveBanner}
              style={{
                backgroundImage: caseItem.details?.image_url
                  ? `url(${caseItem.details.image_url})`
                  : 'url(../../../public/casebg.webp)',
              }}
              onClick={() => handleResultsClick(caseItem.safe_event_id)}
            >
              <div className={styles.dateButton}>
                <div>{caseItem.date}</div>
              </div>
              <div className={styles.bannerInfoBottom}>
                <div className={styles.pullInfo}>
                  <div className={styles.pullValue}>
                    Сейф на{' '}
                    {caseItem.main_prize?.amount?.toLocaleString() || '0'}
                    <StarIcon className={styles.starIcon} />
                  </div>
                </div>
                <div className={styles.resultsButton}>Результаты</div>
              </div>
            </div>
          ))}
        </div>
        {casesArchive.length === 0 && (
          <div className={styles.emptyState}>
            <p>Архив пуст</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CaseArchivePage;
